import moment from "moment";
import { ReportFilterValue } from "../components/NewReportFilters";
import { ReportQueryParams, ReportType } from "../api/types";

// Default window mirrors the API default (last 30 days, today inclusive).
export function defaultFilters(): ReportFilterValue {
  return {
    from: moment().subtract(29, "days").format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
    eventId: "",
  };
}

export function toQueryParams(
  reportType: ReportType,
  filters: ReportFilterValue,
  extra?: Partial<ReportQueryParams>
): ReportQueryParams {
  return {
    reportType,
    from: filters.from || undefined,
    to: filters.to || undefined,
    eventId: filters.eventId || undefined,
    vendorId: filters.vendorId || undefined,
    locationId: filters.locationId || undefined,
    ...extra,
  };
}
